<template>
  <div class="detail">
    <div class="content_box">
      <div class="content">
        <div class="title">
          <div class="title_left">{{ currentItem.title }}</div>
          <div class="title_right">￥{{ currentItem.price }}</div>
        </div>
        <div class="status">
          <div class="status1">任务状态：<span>进行中</span></div>
          <div class="status2">人员数量：{{ currentItem.number}}人</div>
          <div class="status2">截止日期：{{ formatDate(currentItem.date) }}</div>
        </div>
        <div class="line"></div>
        <div class="task_describe">
          <div class="task_title">任务描述</div>
          <div class="tast_content">
            {{ currentItem.nickname }}
            <!-- 根据需求进行定制，以确保软件界面的美观性、易用性和功能性。后端系统ui设计包括登录页、首页、内部子页面，表格表单业务流程数据展示，以及前端代码编写。 -->
          </div>
        </div>
        <div class="skill">
          <div class="skill_title">技能要求</div>
          <div class="skill_content">
            {{ currentItem.totalPrice }}
          </div>
        </div>
        <div class="btn_list">
          <div class="btn_item" @click="open">
            <!-- <img src="../assets/display/icon1.png" alt="">
            <div class="text">我要接单</div> -->
            <el-button type="primary" icon="el-icon-s-cooperation">我要接单</el-button>
          </div>
          <el-button slot="reference" icon="el-icon-star-on" :type="currentItem.is_like == 0 ?'success':'danger'" @click="handleLike">{{ currentItem.is_like == 0 ? '收藏任务' : '已收藏' }}</el-button>
          <!-- <div class="btn_item" style="background-color: #FF3D36;" @click="handleLike">
            <img src="../assets/display/icon2.png" alt="">
            <div class="text">收藏任务</div>
          </div> -->

          <div style="margin-left: 30px;">
            <el-popover placement="top-start" title="+联系方式" width="200" trigger="hover"
              :content="'手机号：'+currentItem.mobile">
              <!-- <el-button slot="reference" type="primary" icon="el-icon-phone-outline">咨询雇主</el-button> -->
            </el-popover>
            
            <!-- <img src="../assets/display/icon3.png" alt="">
            <div class="text">咨询雇主</div> -->
          </div>
        </div>

      </div>
    </div>

  </div>
</template>

<script>
import axios from "axios";
import { information_listApi, take_informationApi, likeApi } from "../api/index";
import moment from "moment"
export default {
  data() {
    return {
      params: {
        page: {
          page_num: 1,
          page_limit: 20
        },
        map: { id:""},
      },
      currentItem:{},
      requireList: [],
      taskStatus: '进行中',
      taskStatusColor: 'green',
      taskDescription: '根据需求进行定制，以确保软件界面的美观性、易用性和功能性。后端系统ui设计包括登录页、首页、内部子页面，表格表单业务流程数据展示，以及前端代码编写。',
      skills: ['ui设计经验', '交互设计体验', '小程序', 'pc端', '移动端'],
    }
  },
  created() {
    let id = this.$route.query.date
    this.getPublishRequire(id)
  },
  methods: {
    async handleLike(){
      const res = await likeApi({
        id: this.currentItem.id
      })
      if(res.data.code==0)return this.$message({
        type: 'error',
        message: res.data.msg
      })
      this.$message({
        type: 'success',
        message: res.data.msg
      });
      if (this.currentItem.is_like==0){
        this.currentItem.is_like=1
      }else{
        this.currentItem.is_like = 0
      }
      // if (this.currentItem.is_like===0){
      //   this.currentItem.is_like =1
      // }else{
      //   this.currentItem.is_like = 0
      // }
    },
    async getPublishRequire(id) {
      this.params.map.id=id
      const res = await information_listApi(this.params)
      if (res.data.code === 1) {
        this.requireList = res.data.data
        this.currentItem = this.requireList.find(item => item.id === id)
        // this.currentItem = res.data.data[0]
        
      }
    },
    open() {
      this.$confirm('您是否确定接此单?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const res = await take_informationApi({ id: this.currentItem.id })
        if (res.data.code == 1) {
          this.$message({
            type: 'success',
            message: '接单成功'
          });
        } else {
          this.$message({
            type: 'error',
            message: res.data.msg
          });
        }
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        });
      });
    },
    formatDate(val){
      return moment(val).format("YYYY-MM-DD")
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep.el-popconfirm{
.el-popconfirm__main{
    margin-bottom: 0 !important;
  }
}

.detail {
  padding-top: 75px;
  .content_box {
    background-color: #f7f8fc;
    padding-top: 51px;
    padding-bottom: 50px;
    .content {
      margin: 0 auto;
      width: 1000px;
      height: 500px;
      padding: 47px 42px;
      background-color: #ffffff;
      box-sizing: content-box;
      padding-bottom: 59px;
      .title {
        display: flex;
        justify-content: space-between;
        font-size: 29px;

        .title_left {
          color: #000000;
        }

        .title_right {
          color: #FF2A2A;
        }
      }

      .status {
        margin-top: 15px;
        display: flex;
        align-items: center;

        .status1 {
          font-size: 20px;
          color: #545454;
          margin-right: 29px;

          span {
            display: inline-block;
            width: 51px;
            height: 26px;
            background: #D1FFD6;
            border-radius: 15px 15px 15px 15px;
            font-size: 12px;
            text-align: center;
            line-height: 26px;
            color: #3DC26E;
          }
        }

        .status2 {
          font-size: 20px;
          margin-right: 30px;
        }
      }

      .line {
        width: 100%;
        height: 1px;
        background-color: #B9B9B9;
        margin: 33px 0 26px 0;
      }

      .task_describe {
        .task_title {
          font-size: 29px;
          margin-bottom: 15px;
        }

        .tast_content {
          font-size: 19px;
        }
      }

      .skill {
        .skill_title {
          font-size: 29px;
          margin: 15px 0 7px 0;
        }

        .skill_content {
          font-size: 19px;
        }
      }

      .btn_list {
        margin-top: 44px;
        display: flex;
        align-items: center;
        .btn_item {
          cursor: pointer;
          // width: 117px;
          // height: 36px;
          // background-color: #3669FF;
          // text-align: center;
          // line-height: 36px;
          // display: flex;
          // align-items: center;
          // justify-content: center;
          margin-right: 29px;
          // border-radius: 5px;
          img {
            width: 20px;
            height: 20px;
            margin-right: 7px;
          }

          .text {
            color: #FFFFFF;
            font-size: 15px;
          }
        }
      }
    }
  }

}
</style>
